import { Injectable } from "@angular/core";
import { JcktlServicePkg } from "./jcktlPkg.service";
import { Jcktl } from "../entity/Jcktl-angular";
import { idNameItem, jkLib } from "jk-service";

/**
 * 個人命運
整體運勢： 了解個人在一段時間內的整體運勢走向，是吉是凶，是順是逆。
健康狀況： 透過卦象，可以窺見身體的健康狀況，以及潛在的疾病隱患。
財運變化： 對於財務狀況、投資理財等方面，易經可以提供一定的參考。
情感婚姻： 對於愛情、婚姻、人際關係等，易經可以揭示潛在的矛盾和解決之道。
2. 事業學業
職業選擇： 幫助個人選擇適合自己的職業道路，發揮自身優勢。
升遷調動： 對於工作中的升遷、調動等變動，易經可以提供參考意見。
考試求學： 對於學業上的考試、升學等，易經可以提供心理上的支持和建議。
3. 家庭和睦
家庭關係： 改善家庭成員之間的關係，化解矛盾，增進和睦。
子女教育： 對於子女的教育問題，易經可以提供一些啟示。
祖業風水： 對於家庭的風水問題，易經也可以提供一定的建議。
4. 時運變化
時機把握： 判斷時機的成熟度，把握最佳的行動時機。
趨吉避凶： 根據卦象，採取適當的措施，趨吉避凶。
變動應對： 面對突發事件和環境變化，如何應對和調整。
5. 其他方面
出行旅遊： 是否適合出行，旅途中的吉凶。
訴訟官司： 對於法律糾紛，易經可以提供一些參考。
失物尋人： 對於失物或失蹤的人，易經可以提供尋找的方向。
 */

// 個人命運-整體運勢  個人命運-健康狀況 個人命運-財運變化 個人命運-情感婚姻 事業學業-職業選擇 事業學業-升遷調動 事業學業-考試求學
// 家庭和睦-家庭關係  家庭和睦-子女教育 家庭和睦-祖業風水 時運變化-時機把握 時運變化-趨吉避凶 時運變化-變動應對
// 其他方面-出行旅遊 其他方面-訴訟官司 其他方面-失物尋人
export const Jcktl005List: idNameItem[] = [
  { "id": "個人命運-整體運勢", "name": "個人命運-整體運勢" },
  { "id": "個人命運-健康狀況", "name": "個人命運-健康狀況" },
  { "id": "個人命運-財運變化", "name": "個人命運-財運變化" },
  { "id": "個人命運-情感婚姻", "name": "個人命運-情感婚姻" },
  { "id": "事業學業-職業選擇", "name": "事業學業-職業選擇" },
  { "id": "事業學業-升遷調動", "name": "事業學業-升遷調動" },
  { "id": "事業學業-考試求學", "name": "事業學業-考試求學" },
  { "id": "家庭和睦-家庭關係", "name": "家庭和睦-家庭關係" },
  { "id": "家庭和睦-子女教育", "name": "家庭和睦-子女教育" },
  { "id": "家庭和睦-祖業風水", "name": "家庭和睦-祖業風水" },
  { "id": "時運變化-時機把握", "name": "時運變化-時機把握" },
  { "id": "時運變化-趨吉避凶", "name": "時運變化-趨吉避凶" },
  { "id": "時運變化-變動應對", "name": "時運變化-變動應對" },
  { "id": "其他方面-出行旅遊", "name": "其他方面-出行旅遊" },
  { "id": "其他方面-訴訟官司", "name": "其他方面-訴訟官司" },
  { "id": "其他方面-失物尋人", "name": "其他方面-失物尋人" },
  { "id": "無法歸類", "name": "無法歸類" }
];
export const SexList: idNameItem[] = [
  { "id": "男", "name": "男" },
  { "id": "女", "name": "女" }
];
@Injectable({
  providedIn: 'root'
})
export class JcktlService extends JcktlServicePkg {
override async newRecord(newItem: Jcktl): Promise<Jcktl> {
    let r = await super.newRecord(newItem);
    //let newItem: Mtrwd = await super.newRecord();
    newItem.TL001 = jkLib.nowDate() + '-' + jkLib.nowTime9();
    newItem.TL002 = jkLib.nowDate();
    newItem.TL013 = new Date();
    return newItem;
  }

}
